module.exports = __webpack_public_path__ + "img/tutorial-f04-02.d6b75726.png";